import * as React from "react";
import { Modal, Button } from "components/bootstrap";
import SavedSearchesOverview from "./SavedSearchesOverview";
const SavedSearchesModal = ({ toggleModal, deleteSavedSearch, activeSavedSearchId }) => /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "large", onHide: toggleModal }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Saved Searches")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
  SavedSearchesOverview,
  {
    deleteSavedSearch,
    activeSavedSearchId,
    onLoadSavedSearch: toggleModal
  }
)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Button, { onClick: toggleModal }, "Cancel")));
export default SavedSearchesModal;
